function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m103.808 121.5h-79.616v-37.5a20 20 0 0 1 20-20h39.616a20 20 0 0 1 20 20z",
  fill: "#4e8ed5"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 39.25,
  fill: "#f2f2f2",
  r: 32.75
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#12304c"
}, /*#__PURE__*/React.createElement("path", {
  d: "m30.192 113.25a1.75 1.75 0 0 1 -1.75-1.75v-19.062a1.75 1.75 0 0 1 3.5 0v19.062a1.75 1.75 0 0 1 -1.75 1.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m103.81 91.5a1.75 1.75 0 0 0 -1.75 1.75v26.5h-76.12v-35.75a18.134 18.134 0 0 1 7.075-14.423 1.75 1.75 0 0 0 -2.145-2.766 21.61 21.61 0 0 0 -8.43 17.189v37.5a1.75 1.75 0 0 0 1.75 1.75h79.62a1.75 1.75 0 0 0 1.75-1.75v-28.25a1.75 1.75 0 0 0 -1.75-1.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m64 73.75a34.34 34.34 0 0 0 21.888-7.85 18.3 18.3 0 0 1 16.172 18.1 1.75 1.75 0 0 0 3.5 0 21.842 21.842 0 0 0 -16.5-21.079 34.488 34.488 0 1 0 -51.472-45.868 1.75 1.75 0 1 0 2.679 2.253 30.886 30.886 0 1 1 -6.667 13.85 1.75 1.75 0 1 0 -3.433-.685 34.529 34.529 0 0 0 33.833 41.279z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m33.217 27.907a1.748 1.748 0 0 0 2.3-.914 31.177 31.177 0 0 1 1.393-2.826 1.75 1.75 0 1 0 -3.058-1.7 34.8 34.8 0 0 0 -1.552 3.14 1.75 1.75 0 0 0 .917 2.3z"
}));

var SvgProfile2 = function SvgProfile2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile2.aca6d26c.svg";
export { ForwardRef as ReactComponent };